import type { NotificationReference as NotificationReferenceType } from '@/@types/notification'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './NotificationReference.module.css'

export interface ReferenceItemProps extends HTMLAttributes<HTMLDivElement> {
	data: NotificationReferenceType | undefined
}

export default function NotificationReference({ data, className, ...props }: ReferenceItemProps) {
	return (
		<div className={clsx(styles.container, className)} {...props}>
			{data?.referenceImageUrl ? (
				<img
					width={60}
					height={60}
					loading="lazy"
					src={data.referenceImageUrl}
					className={styles.image}
				/>
			) : (
				<div className={styles.text}>{data?.content}</div>
			)}
		</div>
	)
}
